// Instead of autoGravity, we'll use a fixed "center" gravity.
import {useEffect, useState} from "react";

import {AdvancedImage} from "@cloudinary/react";
import {fill} from "@cloudinary/url-gen/actions/resize";

import {cld} from "~/firebase/cloudinary";

const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const roundDimension = (dimension: number, roundTo = 100) =>
  Math.round(dimension / roundTo) * roundTo;

const BackgroundImage = () => {
  const [dimensions, setDimensions] = useState({
    width: roundDimension(window.innerWidth),
    height: roundDimension(window.innerHeight),
  });

  useEffect(() => {
    const updateDimensions = debounce(() => {
      setDimensions({
        width: roundDimension(window.innerWidth),
        height: roundDimension(window.innerHeight),
      });
    }, 200); // wait 200ms after the last resize event

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // Use fill cropping with gravity set to "center" so that the image is cropped
  // keeping its center visible regardless of the requested dimensions.
  const img = cld
    .image("Galactic_Blue_and_Purple_s1iq3t")
    .format("auto")
    .quality("auto")
    .resize(
      fill()
        .gravity("center")
        .width(dimensions.width)
        .height(dimensions.height),
    );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: -1,
        overflow: "hidden",
      }}
    >
      <AdvancedImage
        cldImg={img}
        alt="Orbit Dash background splash screen"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
    </div>
  );
};

export default BackgroundImage;
